export default __webpack_public_path__ + "static/media/property_1_10.798b096c.webp";